// extracted by mini-css-extract-plugin
export default {"travel":"index_travel_rU8ws"};